const Options = {
    menu : [
        {
            name: 'Usuarios', 
            path: '/users' 
        },
        // {
        //     name: 'Parámetros', 
        //     path: '/params' 
        // },
        // {
        //     name: 'Niños', 
        //     path: '/children' 
        // },
        // {
        //     name: 'Linea de tiempo', 
        //     path: '/timeline' 
        // },
        // {
        //     name: 'Desarrollo psicomotor', 
        //     path: '/development' 
        // },
        // {
        //     name: 'Vacunas', 
        //     path: '/vaccines' 
        // },
        // {
        //     name: 'Alimentación', 
        //     path: '/feeding' 
        // },
        // {
        //     name: 'Dentición', 
        //     path: '/dentition' 
        // },
        {
            name: 'Auspiciantes', 
            path: '/sponsor' 
        },
        {
            name: 'Publicidad', 
            path: '/advertising' 
        },
    ]
};

export default Options;
